export default "__VITE_ASSET__BJgngfNh__";